<div class="modal-body vtr-modal-pre-scan-info">
	<h1 id="hwscan-pre-scan-info-modal-title" class="error" role="heading">{{ error }}</h1>

	<p id="hwscan-pre-scan-info-modal-description" class="description" role="text"
	>{{ ('hardwareScan.pluginTokens.' + description) | translateDefault:description }}
	</p>

	<div class="row button-row line-separator">
		<vtr-material-button
			linkId="hwscan-pre-scan-info-modal-confirm-btn"
			[label]="buttonText | uppercase"
			[tooltipText] ="buttonText"
			(buttonClick)="onClosing()"
			heightSize="lg">
		</vtr-material-button>
	</div>
	<div class="btn-modal-close">
		<vtr-ui-close-button
			linkId="hwscan-pre-scan-info-modal-close-btn"
			(clickClose)="onClosing()">
		</vtr-ui-close-button>
	</div>
</div>
